export default __webpack_public_path__ + "static/media/EM1810.34I-42024_-25185_0.dd8abdb5.jpg";